export interface UserIdentity {
  UserTranslation?: any;
  Texts?: any;
  WorkFlows?: any;
  ActivityTemplates?: any;
  LayoutDefinitions?: any;
  SessionValues: SessionValue;
  DICompany?: any;
  BWEBSessionId: string;
  DBServer?: any;
  CompanyDB: string;
  CompanyName: string;
  UserCodeForLogin?: any;
  Password?: any;
  UserSign: number;
  EmployeeId: number;
  SalesEmployee: number;
  RoleId: number;
  CardCode?: any;
  CardName?: any;
  ContactName?: any;
  UserCode: string;
  UserMail: string;
  UserFullName: string;
  IsAdmin: string;
  ContactCode: number;
  B1userCode: any;
  B1UserId?: any;
  Area: Area;
  SAPConfiguration?: any;
  Language: string;
  B1language: string;
  ShoppingCartSessionActivated: boolean;
  SharedUser?: any;
  CustomCondition?: any[];
}
export enum Area {
  Public = 4,
  SupplierPortal = 3,
  CustomerPortal = 2,
  B1User = 1,
  Undefined = 0,
}
export interface SessionValue {
  U_ITM_SUB_CONTSTART: string;
  U_ITM_SUB_PAIDTOy: string;
  U_ITM_SUB_PAIDTOM: string;
  U_ITM_PAM_METHOD: string;
  U_ITM_SUB_1ST_INV: string;
  U_ITM_SUB_DOCENTRy: string;
  U_ITM_SUB_ISMONTHLy: string;
  U_ITM_SUB_INSURANCE: string;
  U_ITM_SUB_ACTIVE: string;
  U_ITM_SUB_CONTEND: string;
  U_ITM_SUB_WHS: string;
  U_ITM_SUB_BATCH: string;
  U_ITM_SUB_CA_ACT: string;
  ITM_SUB_CONFIG: string;
  ITM_SUB_PAYMETHOD: string;
  U_ITM_SUB_PRINTM: string;
  Y: string;
}
